import React from 'react';
import { Marquee } from '@/components/ui/marquee';
import { changes } from '@/lib/changeLogItems';

// Sample changelog data - replace with your actual data source
// const changes = [
//   {
//     version: '2.1.0',
//     date: '2024-01-15',
//     description: 'Added AI-powered task recommendations and improved performance'
//   },
//   {
//     version: '2.0.5',
//     date: '2024-01-08',
//     description: 'Bug fixes and UI improvements'
//   }
// ];

const ChangelogMarquee = () => {
  const items = changes.slice(0, 2).map((change) => (
    <div key={change.version} className="px-2 sm:px-4 py-2 bg-card rounded-lg flex-shrink-0">
      <span className="px-1 sm:px-2 py-1 bg-background text-transparent bg-clip-text bg-gradient-to-r from-violet-600 to-teal-400 rounded font-bold text-sm sm:text-base">v{change.version}</span>
      <span className="mx-1 sm:mx-4"></span>
      <span className="opacity-60 text-xs sm:text-sm">{new Date(`${change.date}T12:00:00Z`).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      })}</span>
      <span className="mx-1 sm:mx-4"></span>
      <span className="text-xs sm:text-sm">{change.description}</span>
      <a href="/changelog" className="text-violet-500 ml-1 sm:ml-2 font-bold px-1 sm:px-2 text-xs sm:text-sm">Read more</a>
    </div>
  ));

  return (
    <div className="w-full overflow-hidden relative">
      <div className="absolute top-0 left-0 right-0 h-[0.75px] bg-gradient-to-r from-violet-600 to-teal-400 opacity-50"></div>
      <div className="absolute bottom-0 left-0 right-0 h-[0.75px] bg-gradient-to-r from-violet-600 to-teal-400 opacity-50"></div>
      <Marquee
        items={items}
        reverse={false}
        duration={30}
        gap={16}
        showGradient={true}
        className="py-2 sm:py-4 bg-gradient-to-r from-violet-600/30 to-teal-400/30 w-full"
        contentClassName="text-left px-4 sm:px-6 container mx-auto flex items-center"
        title="Latest Changes"
        titleClassName="uppercase font-bold text-xs tracking-widest"
        titleHref="/changelog"
        pauseOnHover={true}
      />
    </div>
  );
};

export default ChangelogMarquee;